import React from "react";

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 366.176 366.176">
    <path
      fill={props.color}
      d="M149.676 122.528h209a7.5 7.5 0 000-15h-209a7.5 7.5 0 000 15zM358.676 194.528h-209a7.5 7.5 0 000 15h209a7.5 7.5 0 000-15zM358.676 281.527h-209a7.5 7.5 0 000 15h209a7.5 7.5 0 000-15zM108.813 84.516a7.5 7.5 0 000-15H88.5a7.5 7.5 0 000 15h2.656v22.762H88.5a7.5 7.5 0 000 15h20.313a7.5 7.5 0 000-15h-2.657V84.516h2.657z"
    />
    <circle cx="129.176" cy="114.778" r="5.375" />
    <path d="M108.813 172.016a7.5 7.5 0 000-15H88.5a7.5 7.5 0 000 15h2.656v22.762H88.5a7.5 7.5 0 000 15h20.313a7.5 7.5 0 000-15h-2.657v-22.762h2.657zM68.313 172.016a7.5 7.5 0 000-15H48a7.5 7.5 0 000 15h2.656v22.762H48a7.5 7.5 0 000 15h20.313a7.5 7.5 0 000-15h-2.657v-22.762h2.657z" />
    <circle cx="129.176" cy="202.215" r="5.375" />
    <path d="M108.813 258.898a7.5 7.5 0 000-15H88.5a7.5 7.5 0 000 15h2.656v22.762H88.5a7.5 7.5 0 000 15h20.313a7.5 7.5 0 000-15h-2.657v-22.762h2.657zM68.313 258.898a7.5 7.5 0 000-15H48a7.5 7.5 0 000 15h2.656v22.762H48a7.5 7.5 0 000 15h20.313a7.5 7.5 0 000-15h-2.657v-22.762h2.657zM27.813 258.898a7.5 7.5 0 000-15H7.5a7.5 7.5 0 000 15h2.656v22.762H7.5a7.5 7.5 0 000 15h20.313a7.5 7.5 0 000-15h-2.657v-22.762h2.657z" />
    <circle cx="129.176" cy="289.097" r="5.375" />
  </svg>
);

// https://www.flaticon.com/authors/freepik
